import script from "./DataInconsistencyTableTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataInconsistencyTableTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./DataInconsistencyTableTooltip.vue?vue&type=style&index=0&id=1d47cf12&lang=scss"

const __exports__ = script;

export default __exports__